import { useDoubleClickProtection } from '@web_opxp/components';
import { AuthSelectors, ELanguage, LanguageSelectors, useTranslation } from '@web_opxp/features';
import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Action, Dispatch } from 'redux';
import { DEFAULT_BANNER_CAROUSEL } from '../base/constants';
import { Banner } from '../components/Banner';
import { IState } from '../store/state';
import { welcomeBannerClickedAction } from './firebaseActions';
import { isStillWelcomeTime } from './utils';

interface IWelcomeBannerProps {
  show: boolean;
}

const WelcomeBannerFC: React.FC<IWelcomeBannerProps> = ({ show }) => {
  const { t, language } = useTranslation();
  const dispatch = useDispatch<Dispatch<Action<string>>>();

  const onBannerClick = () => dispatch(welcomeBannerClickedAction());
  const onClickHandler = useDoubleClickProtection(onBannerClick);

  if (!show || language !== ELanguage.German) {
    return null;
  }
  const title = t('Welcome.Banner.Title');
  return (
    <Banner canClose={false} show={true} color="purple" className="welcome-banner-container">
      <Link onClick={onClickHandler} className="welcome-banner" to="/welcome_tour">
        <h3 className="large">{title}</h3>
      </Link>
    </Banner>
  );
};

const mapStateToProps = (state: IState) => {
  const bannerCarouselConfig = DEFAULT_BANNER_CAROUSEL;
  const isCarouselEnabled = !!bannerCarouselConfig?.enabled;
  const welcomeHours = bannerCarouselConfig?.welcomeHrs ?? 0;
  const created = AuthSelectors.getCreated(state);
  const isUserNew = isStillWelcomeTime(welcomeHours, created);
  // we need to check for locale to make sure that banner is shown in proper language
  const localeLoaded = !LanguageSelectors.isLoading(state);
  const show = isCarouselEnabled && isUserNew && localeLoaded;
  return {
    show,
  };
};

const WelcomeBanner = connect(mapStateToProps)(WelcomeBannerFC);
export default WelcomeBanner;
